//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BlankComps",0,"Assemblies.SelectComponentList",0],[0,"CncOption",1,0],[0,"CncSensitivity",1,0],[0,"CncTemplate",1,0],[0,"DraftingMode",1,0],[0,"DrawingType",1,0],[0,"EdmOption",1,0],[0,"EdmSensitivity",1,0],[0,"EdmTemplate",1,0],[0,"HideCsys",1,0],[0,"IncludeFixture",1,0],[0,"IncludeOption",1,0],[0,"MasterModelCncPartName",1,0],[0,"MasterModelEdmPartName",1,0],[0,"NameRule",1,0],[0,"OrdinateDimension",1,0],[0,"OutputPDF",1,0],[0,"OutputSameSheet",1,0],[0,"RenameComponent",1,0],[0,"SheetName",1,0],[0,"UseInstance",1,0]],[[["edmTemplateName"],"SetEdmTemplateName",{},1,0],[["cncTemplateName"],"SetCncTemplateName",{},1,0],[["sheetType"],"GetCloneObject",{R_:{cloneObject:"Tooling.CloneObject"}},1,0],[["masterPartName"],"SetMasterModelPartName",{},1,0],[["partNames"],"SetDeleteDrawingParts",{},1,0],[["blankComponents"],"SetSelectedBlanks",{},1,0]],[]];
SPLM.Tooling.EWDraftingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.EWDraftingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.EWDraftingBuilder.ModeOption = Object.freeze({
    "Create" : "Create", "Add" : "Add", "Edit" : "Edit"});

SPLM.Tooling.EWDraftingBuilder.NameOption = Object.freeze({
    "Sh1" : "Sh1", "Sh2" : "Sh2"});

SPLM.Tooling.EWDraftingBuilder.EDMTemplateOption = Object.freeze({
    "EdmTemplate1" : "EdmTemplate1", "EdmTemplate2" : "EdmTemplate2"});

SPLM.Tooling.EWDraftingBuilder.CNCTemplateOption = Object.freeze({
    "CncTemplate1" : "CncTemplate1", "CncTemplate2" : "CncTemplate2"});

SPLM.Tooling.EWDraftingBuilder.DrawingOption = Object.freeze({
    "MasterModel" : "MasterModel", "SelfContained" : "SelfContained"});

export default SPLM;